module.exports = __webpack_public_path__ + "img/img_voucher.3a3c1e0a.png";